import apiRequest from "../../apiCall";

export default function GetAboutUsData() {
  return new Promise((resolve, reject) => {
    apiRequest("GET", "about-us", null, true, true)
      .then((res) => {
        sessionStorage.setItem("aboutusApi", JSON.stringify(res))
        resolve(res);
      })
      .catch((error) => {
        console.error("Error calling home API:", error);
        reject(error);
      });
  });
}

export function PostAboutUsData(formData) {
  sessionStorage.setItem("aboutusApi", JSON.stringify(formData));
  return new Promise((resolve, reject) => {
    apiRequest("POST", "about-us", formData, true, true)
      .then((res) => {
        console.log("post res", res)
        
        resolve(res);
      })
      .catch((error) => {
        console.error("Error calling home API:", error);
        reject(error);
      });
  });
}
